import type { SVGProps } from 'react';
const DawnFlagDE = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-DE_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-DE_svg__a)">
      <path fill="#262626" fillRule="evenodd" d="M0 5.333h22V0H0z" clipRule="evenodd" />
      <g filter="url(#dawn-flag-DE_svg__b)">
        <path
          fill="#F01515"
          fillRule="evenodd"
          d="M0 10.667h22V5.333H0z"
          clipRule="evenodd"
        />
      </g>
      <g filter="url(#dawn-flag-DE_svg__c)">
        <path
          fill="#FFD521"
          fillRule="evenodd"
          d="M0 16h22v-5.333H0z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <filter
        id="dawn-flag-DE_svg__b"
        width={22}
        height={5.333}
        x={0}
        y={5.333}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_543" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_543" result="shape" />
      </filter>
      <filter
        id="dawn-flag-DE_svg__c"
        width={22}
        height={5.333}
        x={0}
        y={10.667}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_543" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_543" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagDE;
